export default "__VITE_ASSET__Bx8ec1MG__"